class utilI18N {

  locale = '??-??';
  currency = '?';
  simboloMoneda = '?';

  constructor (codigoPais) {
    codigoPais = codigoPais.toLowerCase();

    if (codigoPais == 'es') {
      this.locale = 'es-ES';
      this.currency = 'EUR';
    } else if (codigoPais == 'pt') {
      this.locale = 'pt-PT';
      this.currency = 'EUR';
    } else {
      this.locale = 'en-GB';
      this.currency = 'USD';
    }

    this.simboloMoneda = (0).toLocaleString (this.locale, { style: 'currency', currency: this.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 } ).replace(/\d/g, '').trim();
  }

  separadorDecimal () {
    var n = 1.1;
    return n.toLocaleString(this.locale).replace(/\d/g, '');
  }

  cadenaANumerico (cadena) {
    if (typeof cadena == 'string')
      return parseFloat (cadena.replace(/[,.]/g, '.'));
    else
      throw 'El parámetro de entrada no es una cadena';
  }

  cadenaImporte (importe, etiquetaDeMoneda = 'symbol') {
    if (typeof importe == 'string')
      importe = this.cadenaANumerico (importe);
    else if (typeof importe != 'number')
      return importe;

    return importe.toLocaleString (this.locale, { style: 'currency', currency: this.currency, currencyDisplay: etiquetaDeMoneda });
  }

  cadenaImporte2 (importe) {
    return this.cadenaImporte (importe, 'code');
  }

}

export default {
  install (Vue, options) {
    let opciones = { codigoPais: 'es' };
    opciones = {...opciones, ...options};

    Vue.prototype.$utilI18N = new utilI18N (opciones.codigoPais);
  }
}